/**
 * @generated SignedSource<<a281d70c30218cab1350c98fb792e6d3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_navItem$data = {
  readonly dataTn: string | null;
  readonly eventName: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "NavItem_navItem";
};
export type NavItem_navItem$key = {
  readonly " $data"?: NavItem_navItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_navItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_navItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventName",
      "storageKey": null
    }
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};

(node as any).hash = "eac88b0591e794e2f0e7685f8c130927";

export default node;
